import React from "react";
import PropTypes from "prop-types";

// A blocker can stop the embed itself (DuckDuckGo blocks YouTube outright), leaving a
// blank frame, so there's always a way to the video on YouTube.
const WatchOnYouTubeLink = ({ href }) => (
  <p className="youtube-watch-elsewhere">
    Video not showing?{" "}
    <a href={href} rel="noopener noreferrer" target="_blank">
      Watch on YouTube
    </a>
  </p>
);

WatchOnYouTubeLink.propTypes = {
  href: PropTypes.string.isRequired,
};

export default WatchOnYouTubeLink;
